import { TextInputGhost } from '../TextInputGhost';
import { TextInputLiner } from '../TextInputLiner';

import type { TextInputProps } from './types';

const variantComponent = {
  liner: TextInputLiner,
  ghost: TextInputGhost,
};

const TextInput = (props: TextInputProps) => {
  const { variant = 'liner', ref, ...others } = props;

  const InputComponent = variantComponent[variant];

  return <InputComponent ref={ref} {...others} />;
};

TextInput.displayName = 'TextInput';

export default TextInput;
